import { recoveryFor, type Recovery } from "../../../../packages/shared/src/recovery";
import { t as msg } from "./i18n";
import { currentLocale } from "./i18n";
export class ApiError extends Error {
  constructor(
    public code: string,
    message: string,
    public status: number,
    public detail: Record<string, unknown> = {},
  ) {
    super(message);
  }
  get recovery(): Recovery { return (this.detail.recovery as Recovery | undefined) ?? recoveryFor(this.status, this.code); }
}
export async function api<T>(
  path: string,
  method = "GET",
  data?: unknown,
): Promise<T> {
  let response: Response;
  try {
    response = await fetch(path, {
      method,
      credentials: "same-origin",
      headers:
        method === "GET"
          ? { "X-Promise-Language": currentLocale() }
          : {
              "Content-Type": "application/json",
              "X-Promise-Language": currentLocale(),
              "X-Promise-API-Version": "2",
              "X-Requested-With": "PromiseCard",
            },
      body: data === undefined ? undefined : JSON.stringify(data),
    });
  } catch {
    throw new ApiError(
      "network_error",
      msg("We couldn’t reach the server. Please try again."),
      0,
    );
  }
  if (response.status === 204) return undefined as T;
  let result;
  try { result = await response.json(); }
  catch { throw new ApiError("invalid_response", msg("Something went wrong. Please try again."), 503); }
  if (!response.ok)
    throw new ApiError(
      result.error?.code || "request_failed",
      result.error?.message || msg("Please try again."),
      response.status,
      result.error,
    );
  return result as T;
}
export const secret = () =>
  btoa(String.fromCharCode(...crypto.getRandomValues(new Uint8Array(32))))
    .replaceAll("+", "-")
    .replaceAll("/", "_")
    .replaceAll("=", "");
export const friendlyDate = (value?: string | null) =>
  value
    ? new Intl.DateTimeFormat(currentLocale(), {
        month: "short",
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
      }).format(new Date(value))
    : "";
export const statusText = (status: string) =>
  ({
    sent: msg("Waiting to accept"),
    opened: msg("Opened · waiting to accept"),
    accepted: msg("Accepted"),
    redeem_requested: msg("Redemption requested"),
    redeemed: msg("Promise kept"),
    expired: msg("Expired"),
    revoked: msg("Revoked"),
    declined: msg("Declined"),
  })[status] || status;

export const cardStatusText = (card: {
  status: string;
  moderation: string;
  deliveryMode?: string;
  deliveredAt?: string | null;
}) =>
  card.moderation === "pending"
    ? msg("Being checked")
    : card.deliveryMode === "direct" &&
        !card.deliveredAt &&
        card.status !== "revoked"
      ? msg("Not delivered")
      : statusText(card.status);
